import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-unordered-list',
  templateUrl: './unordered-list.component.html',
  styleUrls: ['./unordered-list.component.scss'],
  inputs: ['listItems']
})
export class UnorderedListComponent implements OnInit {

  @Input() listItems: string[];

  constructor() { }

  ngOnInit() {
  }

}
